import { RCOrganization } from "@rcenter/core";

export enum TabsEnum {
    RESERVATIONS = 'reservations',
    RESERVATION = 'reservation',
    PACKAGES = 'packages',
    RENTAL_PRODUCTS = 'rentals',
    PASSES = 'passes',
    CATEGORIES = 'categories',
    PROGRAM_PASSES = 'program_passes',
    BOOKING_PORTALS = 'booking-portals',
}

export enum TAB_ACTIONS {
    CREATE = 'create',
    OVERVIEW = 'overview',
    EDIT = 'edit',
};

export enum RESERVATIONS_LABELS {
    RESERVATIONS = 'Reservations',
    RENTALS = 'Rentals',
    RENTAL_PRODUCT = 'Rental Product',
    RENTAL_PRODUCTS = 'Rental Products',
    PRODUCTS = 'Products',
    PASSES = 'Passes',
    CATEGORIES = 'Categories',
    CREATE_RENTAL_PRODUCT = 'New Product',
    EDIT_RENTAL_PRODUCT = 'Edit Product',
    BOOKING_PORTALS = 'Portals',
};

export enum ReservationsFiltersEnum {
    //TODO: Uncomment after infinite scroll implementation
    // RESOURCE_IDS = 'resourceIds',
    SPORTS = 'sports',
    INSTRUCTOR = 'instructor',
    STATUSES = 'statuses'
};

export interface RentalBreadcrumb {
    label: RESERVATIONS_LABELS;
    to: string;
}

export interface ReservationsMapperProps {
    organization: RCOrganization;
    activeTab: string;
    action?: string;
    id?: string;
    edit?: boolean;
    handleTabChange: (tab: TabsEnum, id?: string, action?: TAB_ACTIONS) => void;
    setBreadcrumbs: (value: RentalBreadcrumb[]) => void;
    canEditReservation: boolean;
    canViewReservation: boolean;
    canCreateCategory: boolean;
    canEditCategory: boolean;
    allowedTabs: TabsEnum[];
}
